import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { GuestListPrivacyEnum } from 'types/event.types';

export interface UpdateGuestListPrivacyResult {
  updateGuestListPrivacy: {
    event: {
      id: number;
      guestListPrivacy: GuestListPrivacyEnum;
    };
    ok: boolean;
  };
}

export interface UpdateGuestListPrivacyVariables {
  input: {
    eventId: number;
    guestListPrivacy: GuestListPrivacyEnum;
  };
}

const UpdateGuestListPrivacyMutation = gql`
  mutation UpdateGuestListPrivacy($input: UpdateGuestListPrivacyInputType!) {
    updateGuestListPrivacy(input: $input) {
      ok
      event {
        id
        guestListPrivacy
      }
    }
  }
`;

export const updateGuestListPrivacy = (
  variables: UpdateGuestListPrivacyVariables
): Promise<UpdateGuestListPrivacyResult> => {
  return gqlClient.request<UpdateGuestListPrivacyResult>(UpdateGuestListPrivacyMutation, variables);
};
